export default {
  name: 'Conférence de Montréal',
  shortName: 'Montréal',
  description:
    'La Conférence de Montréal (CDM) a été lancée par le FEIA en 1994 et réunit des décideurs de toutes les sphères de la société pour aborder les plus grands enjeux actuels.',
  thumbnail: '/images/events/montreal/thumbnail-montreal.jpg',
  link: 'https://www.laconferencedemontreal.com/',
  header: {
    content:
      'La Conférence de Montréal (CDM) a été lancée par le FEIA en 1994 et réunit des décideurs de toutes les sphères de la société pour aborder les plus grands enjeux actuels.'
  },
  bullets: {
    bullet1: {
      number: '30ème',
      label: 'Édition'
    },
    bullet2: {
      number: '2 100+',
      label: 'Participants'
    },
    bullet3: {
      number: '130+',
      label: 'Conférenciers'
    },
    bullet4: {
      number: '40+',
      label: 'Pays Représentés'
    }
  },
  about: {
    title: 'Notre objectif',
    content:
      'Au cours des trois dernières décennies, la CDM a évolué pour devenir un événement de renommée internationale, auquel participent des décideurs des mondes gouvernemental et économique, qui se réunissent afin de discuter de divers sujets tels que l’économie, le leadership mondial et l’innovation. La localisation de l’événement, au cœur du Canada francophone, offre au public un rare aperçu socio-politique et économique qui couvre à la fois une perspective nord-américaine et européenne, tout en mettant en avant les meilleures pratiques du monde entier.'
  },
  next: {
    title: '',
    content: ''
  },
  gallery: {
    title: 'Galerie de photos',
    edition29: {
      title: '29ème édition — Réussir dans un monde en transition',
      index: [
        {
          image: '/images/events/toronto/gallery/16th-toronto-001.jpg'
        }
      ]
    }
  },
  board: {
    uptitle: 'À propos',
    title: 'Bureau des gouverneurs',
    content:
      'Les membres de la direction de la Conférence de Montréal travaillent en étroite collaboration avec un groupe d’individus rigoureusement sélectionnés qui forment notre bureau des gouverneurs. Tous les membres ont été soigneusement désignés pour leurs connaissances approfondies et leur expérience dans leurs domaines respectifs.'
  },
  boardIndex: {
    chairmen: {
      title: 'Présidents',
      index: [
        {
          name: 'Paul Desmarais Jr.',
          title: 'Président du conseil, Power Corporation of Canada (PCC)',
          image: '/images/boards/montreal/paul_desmarais_jr.png'
        },
        {
          name: 'Gil Rémillard',
          title: 'Président fondateur, International Economic Forum of the Americas',
          image: '/images/boards/montreal/Gil_Remillard-2292_HR.jpg'
        }
      ]
    },
    members: {
      title: 'Membres',
      index: [
        {
          name: 'Luis Almagro Lemes',
          info: 'Secrétaire général, Organization of American States (OAS)',
          image: '/images/boards/montreal/almagro-luis.jpg'
        },
        {
          name: 'Joseph J. Andrew',
          info: 'Président mondial, Dentons',
          image: '/images/boards/montreal/joseph-j-andrew.jpg'
        },
        {
          name: 'Audrey Azoulay',
          info:
            "Directrice générale, Organisation des Nations unies pour l'éducation, la science et la culture (UNESCO)",
          image: '/images/boards/montreal/audrey-azoulay.png'
        },
        {
          name: 'Perrin Beatty',
          info: 'Président et chef de la direction, La Chambre de commerce du Canada',
          image: '/images/boards/montreal/perrin-beatty.png'
        },
        {
          name: 'David M. Cote',
          info: 'Président exécutif, Vertiv Holdings',
          image: '/images/boards/montreal/david-m-cote.jpg'
        },
        {
          name: 'Hélène Desmarais',
          info: 'Présidente exécutive, IVADO Labs et présidente du conseil, HEC Montréal',
          image: '/images/boards/montreal/desmarais-helene.jpg'
        },
        {
          name: 'Jacques Delors',
          info: 'Président fondateur, Notre Europe et Ancien président, Commission européenne',
          image: '/images/boards/montreal/jacques-delors.jpg'
        },
        {
          name: 'Orit Gadiesh',
          info: 'Présidente, Bain & Company',
          image: '/images/boards/montreal/orit-gadiesh.png'
        },
        {
          name: 'Glenn Hutchins',
          info:
            'Coprésident du conseil, The Brookings Institution; président du conseil, North Island; et cofondateur, Silver Lake',
          image: '/images/boards/montreal/glenn-hutchins.png'
        },
        {
          name: 'Odile Renaud-Basso',
          info: 'Présidente, Banque européenne pour la reconstruction et le développement (BERD)',
          image: '/images/boards/montreal/odile-renaud-basso.jpg'
        },
        {
          name: 'Jean-Claude Trichet',
          info:
            'Honorary Governor, Bank of France, Former President, European Central Bank, Chairman, Group of Thirty, and Chairman of European Group of the Trilateral Commission Show',
          image: '/images/boards/montreal/jean-claude trichet.jpg'
        }
      ]
    }
  },
  archive: {
    title: 'Archives'
  },
  events: [
    {
      edition: '29ème édition',
      title: 'Réussir dans un monde en transition',
      link: 'https://www.laconferencedemontreal.com/',
      image: '/images/events/montreal/montreal-29th-fr.png'
    }
  ]
}
